/** Matches backend INTERVIEWER_FEEDBACK_TOKEN_TTL_HOURS default (72h). */
export const FEEDBACK_LINK_VALIDITY_LABEL = '3 days';
